import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Selectable} from './selectable';
import {FieldComponent} from '../field/field.component';

@Component({
  selector: 'taxihandgo-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

  @Input()
  public data: Map<string, Selectable>;

  @Input()
  public maxLength: number = -1;

  private _value: string;
  @Output() valueChange = new EventEmitter();

  public current: string = '';

  constructor() {}

  ngOnInit() {
    console.log(this.data);
    const firstSelectionnable: Selectable = this.data.get(this.data.keys().next().value);
    this.current = firstSelectionnable.id;
  }

  selectIsChanged(component: HTMLSelectElement) {
    const value = this.data.get(component.options.item(component.selectedIndex).value);
    this.current = value.id;
    this._value = this.current;
    this.valueChange.emit(this._value);
  }

  @Input()
  get value() {
    return this._value;
  }

  set value(value: string) {
    this._value = value;
    if (this.data) {
      this.current = value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/select/select.component.ts